import {
  GET_ANSWER,
  GET_ANSWER_SUCCESS,
  GET_ANSWER_CLEAN,
  GET_ANSWER_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  answer: undefined,
}

const AnswerGet = (state = initialState, action) => {
  switch (action.type) {
    case GET_ANSWER:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_ANSWER_SUCCESS:
      state = {
        ...state,
        answer: action.payload.answer,
        loading: false,
        done: true,
      }
      break
    case GET_ANSWER_CLEAN:
      state = initialState
      break
    case GET_ANSWER_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default AnswerGet
